<template>
  <div class="ui-drawer">
    <div class="back-gray"
    :class="{ 'back-gray-show': openDrawer === true}"
    @click="switchDrawer">
    </div>
    <img
      @click="switchDrawer"
      :src="`${rootUrl}/img/drawer.png`"
      class="drawer-button"
      alt="ドロワーメニュー"
    />
    <div
      class="drawer-menu"
      :class="{
        'open-drawer': openDrawer === true,
        'close-drawer': openDrawer === false,
      }"
    >
      <div class="drawer-header">
        <img
          @click="switchDrawer"
          :src="`${rootUrl}/img/close.png`"
          class="close-button"
          alt="閉じるドロワーメニュー"
        />

      </div>
      <div class="drawer-body" @click="switchDrawer">
        <div class="drawer-item">
          <router-link to="/">トップ</router-link>
        </div>
        <div class="drawer-item">
          <router-link to="/category/fruits">ドライフルーツ</router-link>
        </div>
        <div class="drawer-item">
          <router-link to="/category/nuts">ナッツ</router-link>
        </div>
        <div class="drawer-item">
          <router-link to="/category/tea">フルーツティー</router-link>
        </div>
        <div class="drawer-item">
          <router-link to="/contact">お問い合わせ</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UiDrawer",
  data() {
    return {
      openDrawer: false,
    };
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
  methods: {
    switchDrawer() {
      this.openDrawer = this.openDrawer === false ? true : false;
    },
  },
};
</script>

<style lang="scss" scoped>
$width: 230px;
.drawer-button {
  width: 50px;
  cursor: pointer;
  @media screen and (max-width: 767px){
    width: 40px;
  }
}
.drawer-menu {
  transition: all 1s 0s ease;
  position: fixed;
  top: 0;
  background-color: var(--beige);
  padding: 5px 10px 50px 10px;
  box-sizing: border-box;
  z-index: 999;
  width: $width;
  .drawer-header {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    img.close-button {
      width: 20px;
      margin: 20px;
      cursor: pointer;
    }
  }
  .drawer-body {
    // background-color: var(--beige);
    .drawer-item {
      text-align: initial;
        border-top: 1px solid whitesmoke;
      
      padding: 18px 10px;
     
      &:last-child {
        border-bottom: 1px solid whitesmoke;
      }
      a {
        text-decoration: none;
        color: var(--brown);
         &:hover{
          // background-color: var(--beige);
          font-weight: bold;
          // color: var(--orange);
        }
      }
    }
  }
}
.open-drawer {
  transform: translateX(-$width);
  // right: translateX(-$width);
  right: -$width;
}
.close-drawer {
  transform: translateX($width);
  right: -$width;
  // right: 0-$width;
}

.back-gray {
  display: none;
  position: fixed;
  z-index: 995;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color:gray;
  opacity: 0.4;
}
.back-gray-show {
  display: initial;
}
</style>
